import { useContext, useEffect, useState } from 'react'
import Context from './Context'
// Antd
import { SearchOutlined } from '@ant-design/icons'
import { Input, DatePicker } from 'antd'
// components
import BaseLayout from 'components/BaseLayout'
import TableComponent from 'components/Table'
import { ColumnsType } from 'components/Table/interface'
// helpers
import get from 'lodash/get'
import SelectFilter from 'components/SelectFilter'
import LocationCell from './Cells/LocationCell'
import ActionCell from './Cells/ActionCell'
import { isBefore, endOfDay, startOfDay } from 'date-fns'
import dayjs from 'dayjs'
import { actionsFilters } from './actionsFilterValues'

const { RangePicker } = DatePicker

const columns: ColumnsType<any> = [
  {
    title: 'Usuario',
    dataIndex: 'name',
    type: 'CommonCell'
  },
  {
    title: 'Email',
    dataIndex: 'username',
    type: 'CommonCell'
  },
  {
    title: 'Acción',
    dataIndex: 'actionName',
    render: ActionCell
  },
  {
    title: "Localización",
    dataIndex: "ipAddress",
    render: LocationCell
  },
  {
    title: 'Navegador',
    dataIndex: 'userAgent',
    type: 'CommonCell',
    width: '1.5rem'
  },
  {
    title: "Fecha de acción",
    dataIndex: 'date',
    type: "date"
  },
]

const Layout: React.FC = () => {
  const {
    states: { filterSelected, page, searchInput, selectedUser, open, dates, typeSelected },
    actions: { setFilterSelected, setPage, setSearchInput, setDates, setTypeSelected },
    queryHandler: { isFetching, data }
  } = useContext(Context)
  const [filter, setFilter] = useState('')

  const filteredData = get(data, "data", [])
  const total = get(data, "total", 0)

  useEffect(() => {
    const time = setTimeout(() => {
      if (filter != searchInput) setSearchInput(filter)
    }, 600)
    return () => clearTimeout(time)
  }, [filter])

  return (
    <>
      <BaseLayout
        title="Logs"
        bordered={false}
        extra={
          <RangePicker
            allowClear={false}
            value={dates}
            onChange={(val) => setDates([
              dayjs(startOfDay(val[0].toDate())),
              dayjs(endOfDay(val[1].toDate()))
            ])}
            disabledDate={currentDate =>
              !isBefore(currentDate.toDate(), endOfDay(new Date()))
            }
          />
        }
      >
        <Input
          size="large"
          placeholder="Busca por nombre"
          prefix={<SearchOutlined />}
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
          <SelectFilter
            options={actionsFilters}
            value={filterSelected}
            setValue={setFilterSelected}
            placeholder='Seleccione una accion'
            noBadge
          />
        </div>
        <TableComponent
          emptyData={filteredData.length === 0 && !isFetching}
          columns={columns}
          data={filteredData}
          rows={7}
          loading={isFetching}
          page={page}
          total={total}
          setPage={setPage}
        />
      </BaseLayout>
    </>
  )
}

export default Layout
